import { fullName } from "@Utils/utils"

const patientActivities = {
    physicalActivity: {
        title: "Activité physique",
        description: "Modérée"
    },
    levelGroup: {
        title: "Groupe de niveau",
        description: "Activité Physique Adaptée niveau 2"
    },
    barriers: {
        title: "Freins",
        description: "Situation professionnelle "
    },
    representations: {
        title: "Représentations",
        description: "Hérédité de la maladie, traitements"
    },
    levers: {
        title: "Leviers",
        description: "Aidant famillial"
    },
    skills: {
        title: "Compétences à acquérir",
        description: "Gérer son traitement en toutes circonstances"
    },
    goals: {
        title: "Objectifs",
        description: "Diététique : \n APA: \n Psycho :\n Médical :\n "
    },
    motivation: {
        title: "Motivation",
        description: "Préparation selon Prochaska"
    }
}

const defaultUserInfos = (user) => ({
    fullName: {
        title: "Nom et prenom",
        value: fullName(user?.firstName, user?.lastName)
    },
    age: {
        title: "Age",
        value: "(non renseigné)"
    },
    height: {
        title: "Taille",
        value: "(non renseigné)"
    },
    weight: {
        title: "Poids",
        value: "(non renseigné)"
    }
})

const defaultAgreementPayload = {
    professionalIds: []
}

const handleSetCheckedProfessional = ({ newProfessionalId, setPayload }) => {
    setPayload((prev) => {
        const prevIds = prev
        if (prevIds?.length > 0) {
            if (newProfessionalId && prevIds?.includes(newProfessionalId)) {
                const res = prevIds.filter((item) => item !== newProfessionalId)
                return res
            }

            return [...prevIds, newProfessionalId]
        }
        return [newProfessionalId]
    })
}

const handleCheckedProfessionalStatus = ({ payload, professionamId, setPayload }) => {
    if (payload?.length > 0 && payload?.includes(professionamId)) {
        return "checked"
    }
    return "unchecked"
}

const handlePrecheck = ({ setPayload, professionals }) => {
    if (professionals?.length > 0) {
        const accepted = professionals.filter(
            (item) => item.isAcceptedByPatient === 1 || item.isAcceptedByProfessional === 1
        )
        const acceptedIds = Array.from(accepted, (item) => item.id)

        if (acceptedIds?.length > 0) {
            setPayload(acceptedIds)
        }
    }
}

export {
    handleCheckedProfessionalStatus,
    handleSetCheckedProfessional,
    patientActivities,
    defaultUserInfos,
    defaultAgreementPayload,
    handlePrecheck
}
